import { FC } from "react";
import SelectEduStep from "./SelectEduStep";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

const Block = styled.div<{
  marginLeft: number;
  marginBottom: number;
}>`
  ${props => props.marginLeft ? `margin-left: ${props.marginLeft}px;` : ''}
  ${props => props.marginBottom ? `margin-bottom: ${props.marginBottom}px;` : ''}

  .label {
    margin-right: 10px;
  }
`;

interface IProps {
  eduStepCode: string|undefined;
  setEduStepCode: (eduStepCode: string) => void;
  marginLeft?: number;
  marginBottom?: number;
};

const SelectEduStepContainer: FC<IProps> = ({
  eduStepCode,
  setEduStepCode,
  marginLeft = 0,
  marginBottom = 0,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <label>{t('common.label.1')}</label>
      <SelectEduStep
        eduStepCode={eduStepCode}
        setEduStepCode={setEduStepCode}
      />
    </>
  );
};

export default SelectEduStepContainer;
